import { DenomTrace } from "@terra-money/terra.js"
import { MsgExecuteContract } from "cosmes/client"
import { useWallet } from "providers/WalletProvider"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { DENOM, FACTORY_ADDRESS } from "utils/Constants"
import { formatNumber } from "utils/Functions"
import { queryBalance, querySmartContract } from "utils/RpcHelper"

export function RegisterTokenPage() {
    const { address: walletAddress, post } = useWallet()
    const [address, setAddress] = useState("")
    const [tokenInfo, setTokenInfo] = useState<{ name: string, symbol: string }>()
    const [tokenFee, setTokenFee] = useState<string>()
    const [availableFee, setAvailableFee] = useState<{ [key: string]: number }>({})
    const [feeInfos, setFeeInfos] = useState<{ [key: string]: { symbol: string } }>({})
    const navigate = useNavigate()

    const loadConfig = async () => {
        try {
            const { register_fee } = await querySmartContract(FACTORY_ADDRESS, { config: {} })
            for (const key of Object.keys(register_fee)) {
                const { symbol } = await querySmartContract(key, { token_info: {} })
                setFeeInfos(prev => ({ ...prev, [key]: { symbol: symbol } }))
            }
            setAvailableFee(Object.entries(register_fee).reduce((prev, [key, value]) => ({ ...prev, [key]: Number(value) }), {}))
        } catch {
        }
    }

    useEffect(() => {
        loadConfig()
    }, [])

    const loadTokenInfo = async () => {
        try {
            const data = await querySmartContract(address, { token_info: {} })
            setTokenInfo(data)
        } catch {
            alert("Cannot load token info, please make sure the address is correct cw20 address")
            setAddress("")
        }
    }

    useEffect(() => {
        if (address) loadTokenInfo()
    }, [address])


    const register = async () => {
        if (!walletAddress) return alert("Please connect your wallet first")
        if (!address) return alert("Please enter the token address")
        if (!tokenFee) return alert("Please select fee option")

        try {
            const registerMsg = {
                register_token: {
                    token_address: address
                }
            };

            let msg = undefined;
            const { is_whitelisted } = await querySmartContract(FACTORY_ADDRESS, { check_whitelist: { token: address } })

            if (is_whitelisted == true) {
                alert("Congratulation!!, your token is whitelisted for free register")

                msg = new MsgExecuteContract({
                    contract: FACTORY_ADDRESS,
                    funds: [],
                    sender: walletAddress,
                    msg: registerMsg
                })
            } else {
                const fee = availableFee[tokenFee]
                const { balance } = await querySmartContract(tokenFee, { balance: { address: walletAddress } })
                if ((!balance || !fee) || balance < fee) return alert("Your balance is not enough to pay the fee")

                msg = new MsgExecuteContract({
                    sender: walletAddress,
                    contract: tokenFee,
                    funds: [],
                    msg: {
                        send: {
                            msg: Buffer.from(JSON.stringify(registerMsg)).toString("base64"),
                            contract: FACTORY_ADDRESS,
                            amount: fee.toString()
                        }
                    },
                })
            }


            const txHash = await post({
                msgs: [msg],
                memo: `Register burn token ${tokenInfo?.symbol}`
            }, [])

            navigate("/tx-loading/" + txHash)
        } catch (e) {
            console.log(e)
            alert("error: " + e + ", (PLEASE REPORT TO DEVELOPER)")
        }

    }

    return <div className="w-100 p-2 px-4">
        <h4>Register your token</h4>
        <p className="text-muted">Register for burn dashboard</p>

        <div className="form-group">
            <label htmlFor="token-address">Address</label>
            <input
                onChange={({ target }) => setAddress(target.value)}
                value={address}
                type="text"
                className="form-control"
                id="token-address"
                placeholder="Enter Token Address" />
        </div>

        <div className="form-group">
            <label>Name</label>
            <span className="form-control">{tokenInfo?.name ?? "Token Name"}</span>
        </div>
        <div className="form-group">
            <label>Symbol</label>
            <span className="form-control">{tokenInfo?.symbol ?? "Token Symbol"}</span>
        </div>

        {
            Object.entries(availableFee).length > 0 && <div className="form-group">
                <label htmlFor="fee">Fee</label>
                <select
                    onChange={({ target }) => setTokenFee(target.value)}
                    className="form-control"
                    id="pair-address">
                    <option>Select Fee</option>
                    {
                        Object.entries(availableFee).map(([address, amount]) => <option value={address}>{amount / 1e6} {feeInfos[address]?.symbol}</option>)
                    }
                </select>
            </div>
        }

        <button type="button" onClick={register} className="btn btn-primary w-100 btn-lg">Register</button>
    </div>
}   